import { render } from "./DeploymentHealthAlerts.vue?vue&type=template&id=2fbb171c&scoped=true&ts=true"
import script from "./DeploymentHealthAlerts.vue?vue&type=script&lang=ts"
export * from "./DeploymentHealthAlerts.vue?vue&type=script&lang=ts"

import "./DeploymentHealthAlerts.vue?vue&type=style&index=0&id=2fbb171c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbb171c"]])

export default __exports__